import { useTranslation } from 'react-i18next';
import styles from './EmploymentInfoText.module.scss';
import React from 'react';

const EmploymentInfoText = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.employment_info_text}>
        <h6>{t('employmentTemplatesInfo.employeeOnboarding')}</h6>
        <p>{t('employmentTemplatesInfo.supportCompliance')}</p>
        <ul>
          <li>{t('employmentTemplatesInfo.fairWork')}</li>
          <li>{t('employmentTemplatesInfo.casualEmployment')}</li>
          <li>{t('employmentTemplatesInfo.taxFile')}</li>
          <li>{t('employmentTemplatesInfo.superannuationStandardChoiceForm')}</li>
          <li>{t('employmentTemplatesInfo.writtenEmploymentContract')}</li>
          <li>{t('employmentTemplatesInfo.positionDescription')}</li>
          <li>{t('employmentTemplatesInfo.safetyInduction')}</li>
        </ul>
        <h6>{t('employmentTemplatesInfo.subcontractorEngagement')}</h6>
        <p>{t('employmentTemplatesInfo.ensureClarity')}</p>
        <ul>
          <li>
            {t('employmentTemplatesInfo.provideA')}{' '}
            <strong>{t('employmentTemplatesInfo.contractorAgreement')}</strong>{' '}
            {t('employmentTemplatesInfo.outliningScope')}
          </li>
          <li>
            {t('employmentTemplatesInfo.collect')}{' '}
            <strong>{t('employmentTemplatesInfo.abnDetails')}</strong>
          </li>
          <li>
            {t('employmentTemplatesInfo.request')}{' '}
            <strong>{t('employmentTemplatesInfo.insuranceCertificates')}</strong>{' '}
            {t('employmentTemplatesInfo.publicLiability')}
          </li>
          <li>
            {t('employmentTemplatesInfo.confirm')}{' '}
            <strong>{t('employmentTemplatesInfo.invoicing')}</strong>
          </li>
          <li>
            {t('employmentTemplatesInfo.provideAny')}{' '}
            <strong>{t('employmentTemplatesInfo.siteSafety')}</strong>
          </li>
          <li>
            {t('employmentTemplatesInfo.confirmExpectations')}{' '}
            <strong>{t('employmentTemplatesInfo.confidentially')}</strong>
          </li>
        </ul>
        <p className={styles.disclaimer_block}>
          {t('employmentTemplatesInfo.generalInNature')}{' '}
          <strong>{t('employmentTemplatesInfo.legalAdvice')}</strong>.{' '}
          {t('employmentTemplatesInfo.ensureCompliance')}
        </p>
      </div>
    </>
  );
};

export default EmploymentInfoText;
